"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authTypeNameWithFetch = exports.authTypeName = exports.authTypeDeserialize = void 0;
const User_1 = require("../../controllers/User");
const expect_1 = __importDefault(require("../../util/expect"));
const BaseUser_1 = require("../BaseUser");
const authTypeAll = ['ADMIN', 'USER', 'UNAUTHENTICATED'];
function authTypeDeserialize(value) {
    if (!authTypeAll.includes(value)) {
        throw new Error(`Invalid AuthType: ${value}`);
    }
    return value;
}
exports.authTypeDeserialize = authTypeDeserialize;
function authTypeName(type) {
    switch (type) {
        case 'ADMIN':
            return 'System';
        case 'USER':
            return 'User';
        case 'UNAUTHENTICATED':
            return 'Unauthenticated user';
    }
}
exports.authTypeName = authTypeName;
async function authTypeNameWithFetch(type, uid, database) {
    switch (type) {
        case 'ADMIN':
            return 'System';
        case 'USER': {
            const user = await (0, User_1.userRead)((0, expect_1.default)(uid), database);
            return (0, BaseUser_1.baseUserCasualName)(user);
        }
        case 'UNAUTHENTICATED':
            return 'Unauthenticated user';
    }
}
exports.authTypeNameWithFetch = authTypeNameWithFetch;
